import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Steven 身為一名新創公司的 PM，在公司帶領開發團隊從無到有，逐步導入敏捷精神，創造願意接受失敗的開發團隊。同時有感於新創公司的市場變化太快，因此也會使用 DDD 的各項元素於專案開發中。`}</p>
    <p>{`在本次議程中， Steven 將為大家分享如何讓團隊勇於接受失敗、擁抱失敗，並且聊到他們使用了哪些 DDD 的元素幫助團隊更能適應變化！`}</p>
    <p>{`之前 Steven 就有在 DDD Meetup 演講分享過他的經驗，得到不少迴響。因此如果你剛好身在新創，對 DDD 與敏捷有興趣，千萬別錯過 Steven 的演講！`}</p>
    <p>{`Linkedin : `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/chiwen-cheng/"
      }}>{`https://www.linkedin.com/in/chiwen-cheng/`}</a></p>
    <p>{`相關演講經歷:`}</p>
    <ol>
      <li parentName="ol">{`2020/8 DDD TW`}</li>
      <li parentName="ol">{`2020/3 Code for marketing`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      